import React from 'react';

const Help = () => {
  return (
    <>
      <p>Help Pages</p>
    </>
  )
}
export default Help